import { useContext } from 'react';
import { ConfigContext } from '../contextProviders';
import { Config } from '../config';

export const useConfig: () => Config = () => {
    return useContext(ConfigContext) || ({} as Config);
};
